module.exports = __webpack_public_path__ + "img/promo-fertigen-bgr.9858e4ef.svg";